export const NumpadNumberLayout = [
  ['7', '8', '9'],
  ['4', '5', '6'],
  ['1', '2', '3'],
  ['.', '0', 'ENTER']
];

export const NumpadUtilityKeys = ['BACKSPACE', 'CLEAR', 'DRAG', 'HIDE'];
